import React from 'react';
import { Sun, Moon } from 'lucide-react';
import { useTheme } from '../context/ThemeContext';

const ThemeToggle: React.FC = () => {
    const { theme, toggleTheme } = useTheme();

    return (
        <button
            onClick={toggleTheme}
            className={`relative p-2 rounded-lg transition-all duration-300 focus:outline-none focus:ring-2 focus:ring-offset-2 w-10 h-10 flex items-center justify-center overflow-hidden
        ${theme === 'dark'
                    ? 'bg-gray-800 text-yellow-400 hover:bg-gray-700 focus:ring-yellow-400'
                    : 'bg-blue-50 text-blue-600 hover:bg-blue-100 focus:ring-blue-500'}`}
            title={`Switch to ${theme === 'dark' ? 'light' : 'dark'} mode`}
        >
            <div className={`absolute transition-transform duration-500 transform ${theme === 'dark' ? 'rotate-0' : 'rotate-90 scale-0'}`}>
                <Moon size={20} className="fill-current" />
            </div>
            <div className={`absolute transition-transform duration-500 transform ${theme === 'dark' ? '-rotate-90 scale-0' : 'rotate-0'}`}>
                <Sun size={20} className="fill-current" />
            </div>
        </button>
    );
};

export default ThemeToggle;
